module.exports = __webpack_public_path__ + "img/login-icon-scene.599c6f0b.png";